export default {
    CreateReceipt: 0,
    NotCreateReceipt: 1,
};
  